import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Directive, Inject, ElementRef, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';

@Directive({
  selector: '[preloadImg]',
  standalone: true,
})
export class ImagePreloadDirective implements OnInit {
  constructor(
    @Inject(DOCUMENT) public doc: Document,
    @Inject(PLATFORM_ID) private platformId: object,
    private el: ElementRef,
    public renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.renderer.setAttribute(this.el.nativeElement, 'fetchpriority', 'high');
    this.renderer.removeAttribute(this.el.nativeElement, 'loading');

    if (isPlatformServer(this.platformId)) {
      const src = this.el.nativeElement.getAttribute('src');
      if (src) {
        const link: HTMLLinkElement = this.doc.createElement('link');
        link.setAttribute('as', 'image');
        link.setAttribute('rel', 'preload');
        link.setAttribute('fetchpriority', 'high');
        link.setAttribute('href', src);
        this.renderer.appendChild(this.doc.head, link);
      }
    }
  }
}
